import * as ReactDOMClient from 'react-dom/client'
import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { createBrowserHistory, createMemoryHistory } from 'history'
import {
  HistoryAdaptedRouter,
  IHistory4,
  useUuiServices,
  UuiContext,
} from '@epam/uui-core'
import { ErrorHandler, skinContext } from '@epam/loveship'
import { Snackbar, Modals } from '@epam/uui-components'
import { IS_ON_IFRAME, SSO_URL } from '@stlm/common-ui/lib'
import { store } from './store'
import { router } from './routes/router'

import '@epam/uui-components/styles.css'
import '@epam/uui/styles.css'
import '@epam/loveship/styles.css'

export const history = (IS_ON_IFRAME
  ? createMemoryHistory()
  : createBrowserHistory()) as unknown as IHistory4

const UuiEnhancedApp = () => {
  const uuiRouter = new HistoryAdaptedRouter(history)
  const { services } = useUuiServices({
    router: uuiRouter,
    skinContext,
    apiReloginPath: SSO_URL,
  })

  return (
    <UuiContext.Provider value={services}>
      <ErrorHandler>
        <RouterProvider router={router} />
        <Snackbar />
        <Modals />
      </ErrorHandler>
    </UuiContext.Provider>
  )
}

const RoutedApp = () => (
  <Provider store={store}>
    <UuiEnhancedApp />
  </Provider>
)

const container = document.getElementById('root')
if (container) {
  const root = ReactDOMClient.createRoot(container)
  root.render(<RoutedApp />)
}
